module.exports = __webpack_public_path__ + "img/emoji_sunny.cba35fb7.png";